export class MiGenParameters{
TagName:string;
Value :string;
Disabled:boolean;
Modified :Date;
}